import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

export default function SimpleDeleting({ haveVolumeSnapshotsToDelete, deleteAll }) {
  const classes = useStyles()
  return (
    <>
      <Text variant="subtitle2">
        <div className={clsx(classes.circleIcon, classes.blueCircle)}>
          <FontAwesomeIcon className={classes.blueIcon} size="md">
            arrows-rotate
          </FontAwesomeIcon>
        </div>
        Deletion in progress
      </Text>
      {haveVolumeSnapshotsToDelete && (
        <Text variant="body2">
          <b>NOTE:</b> VM deletion will take longer as dependent volume snapshots are cleaned up.
        </Text>
      )}
      <div className={classes.simpleResultsTable}>
        <Text variant="body2">Virtual Machines:</Text>
        <Text variant="caption1">
          <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
            spinner-third
          </FontAwesomeIcon>
          Deleting...
        </Text>
        {deleteAll && (
          <>
            <Text variant="body2">Associated Volumes:</Text>
            <Text variant="caption1">
              <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
                spinner-third
              </FontAwesomeIcon>
              Deleting...
            </Text>
            <Text variant="body2">Associated Ports:</Text>
            <Text variant="caption1">
              <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
                spinner-third
              </FontAwesomeIcon>
              Deleting...
            </Text>
          </>
        )}
      </div>
    </>
  )
}
